import { useState } from "react";
import { GridWrap } from "../ui/wrappers/GridWrap/GridWrap";
import { TextButton } from "../ui/buttons/TextButton/TextButton";
import { useGetProductsQuery } from "../../store/products/productsApi";
import LoadBlock from "../view/LoadBlock/LoadBlock";
import { TextError } from "../ui/errors/TextError/TextError";
import { ProductItem } from "../view/ProductItem/ProductItem";
import { ProductModal } from "../view/ProductModal/ProductModal";

export const Products = () => {
  const {
    data: products,
    error,
    isLoading,
    refetch,
  } = useGetProductsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [editingProduct, setEditingProduct] = useState<string | undefined>(
    undefined,
  );
  const [openModal, setOpenModal] = useState(false);

  const closeModal = () => setOpenModal(false);

  const addModal = () => {
    setEditingProduct(undefined);
    setOpenModal(true);
  };

  const editModal = (uuid: string) => {
    setEditingProduct(uuid);
    setOpenModal(true);
  };

  return (
    <>
      {isLoading ? (
        <LoadBlock />
      ) : error ? (
        <TextError text="Ошибка при загрузке" />
      ) : (
        <>
          <TextButton
            text="Добавить новый товар"
            color="black"
            margin="0 0 2rem 0"
            action={addModal}
          />
          <GridWrap column={3}>
            {products && products.length > 0
              ? products.map((item) => (
                  <ProductItem
                    key={item.uuid}
                    item={item}
                    editAction={editModal}
                    updatePage={refetch}
                  />
                ))
              : null}
          </GridWrap>
        </>
      )}
      {openModal && (
        <ProductModal
          uuidItem={editingProduct}
          closeModal={closeModal}
          updatePage={refetch}
        />
      )}
    </>
  );
};
